import React from "react";
import Field from "../shared/Field";
import { inputStyle } from "../shared/inputStyle";
import { formatAmountInput } from "../utils/format";
import { TERMINATION_OPTIONS } from "../data/constants";

export default function FinancialForm({
  unitLabel,
  financialBasis,
  setFinancialBasis,
  claimAmount,
  setClaimAmount,
  agreedFee,
  setAgreedFee,
  termination,
  setTermination,
}) {
  return (
    <div className="space-y-5">
      <Field label="مبنای محاسبه حق‌الوکاله">
        <div className="grid grid-cols-2 gap-2">
          <button
            type="button"
            onClick={() => setFinancialBasis("tariff")}
            className={`rounded-lg px-3 py-2 text-xs ${financialBasis === "tariff" ? "bg-primary text-neutral-100" : "bg-white text-neutral-800"}`}
          >
            بر اساس بهای خواسته (تعرفه پلکانی)
          </button>
          <button
            type="button"
            onClick={() => setFinancialBasis("agreed")}
            className={`rounded-lg px-3 py-2 text-xs ${financialBasis === "agreed" ? "bg-primary text-neutral-100" : "bg-white text-neutral-800"}`}
          >
            بر اساس مبلغ مندرج در وکالت‌نامه (توافقی)
          </button>
        </div>
      </Field>

      {financialBasis === "tariff" ? (
        <Field label={`بهای خواسته (${unitLabel})`}>
          <input
            type="text"
            inputMode="numeric"
            value={claimAmount}
            onChange={(e) => setClaimAmount(formatAmountInput(e.target.value))}
            placeholder="مثلاً 5,000,000,000"
            className="input"
            style={inputStyle}
          />
        </Field>
      ) : (
        <Field label={`مبلغ حق‌الوکاله مندرج در وکالت‌نامه (${unitLabel})`}>
          <input
            type="text"
            inputMode="numeric"
            value={agreedFee}
            onChange={(e) => setAgreedFee(formatAmountInput(e.target.value))}
            placeholder="مثلاً 132,000,000"
            className="input"
            style={inputStyle}
          />
        </Field>
      )}

      <Field label="نحوه ختم پرونده">
        <select
          value={termination}
          onChange={(e) => setTermination(e.target.value)}
          className="input"
          style={inputStyle}
        >
          {TERMINATION_OPTIONS.map((o) => (
            <option key={o.id} value={o.id}>
              {o.label}
            </option>
          ))}
        </select>
      </Field>
    </div>
  );
}
